export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
}

export const isVideo = mediaType => mediaType === MEDIA_TYPES.VIDEO

export const getAcceptedTypes = mediaType =>
  isVideo(mediaType) ? 'video/*' : 'image/*'

export const getMaxFileSize = mediaType => (isVideo(mediaType) ? 200 : 20)

export const toDateInputValue = value => {
  if (!value) return ''
  return new Date(value).toISOString().split('T')[0]
}

export const buildCustomerDisplayPayload = ({
  values,
  fileUrl,
  editMode,
  customerSettings = [],
}) => {
  if (!editMode) {
    return values.branchOfficeIds.map(branchOfficeId => ({
      Name: values.name,
      MediaType: values.mediaType,
      FileUrl: fileUrl,
      DisplayOrder: values.displayOrder || undefined,
      StartDate: new Date(values.startDate).toISOString(),
      EndDate: new Date(values.endDate).toISOString(),
      BranchOfficeId: branchOfficeId,
      CompanyId: values.companyId,
      Status: true,
    }))
  }

  const selectedBranchIds = values.branchOfficeIds || []

  const existingByBranchId = customerSettings.reduce((acc, item) => {
    acc[item.BranchOfficeId] = item
    return acc
  }, {})

  const selectedPayload = selectedBranchIds.map(branchOfficeId => {
    const existingItem = existingByBranchId[branchOfficeId]

    return {
      CustomerDisplaySettingId:
        existingItem?.CustomerDisplaySettingId ||
        '00000000-0000-0000-0000-000000000000',
      Name: values.name,
      MediaType: values.mediaType,
      FileUrl: fileUrl,
      DisplayOrder: values.displayOrder || undefined,
      StartDate: new Date(values.startDate).toISOString(),
      EndDate: new Date(values.endDate).toISOString(),
      BranchOfficeId: branchOfficeId,
      CompanyId: values.companyId,
      Status: values.status,
    }
  })

  const removedPayload = customerSettings
    .filter(item => !selectedBranchIds.includes(item.BranchOfficeId))
    .map(item => ({
      CustomerDisplaySettingId: item.CustomerDisplaySettingId,
      Name: values.name,
      MediaType: values.mediaType,
      FileUrl: fileUrl,
      DisplayOrder: item.DisplayOrder,
      StartDate: new Date(values.startDate).toISOString(),
      EndDate: new Date(values.endDate).toISOString(),
      BranchOfficeId: item.BranchOfficeId,
      CompanyId: item.CompanyId || values.companyId,
      Status: false,
    }))

  return [...selectedPayload, ...removedPayload]
}
